import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

type CompassionateRequest = {
  id: number;
  program_id: number;
  status: string;
  patient_first_name: string;
  patient_last_name: string;
  patient_date_of_birth: string;
  patient_gender: string;
  patient_address_line1: string;
  patient_address_line2: string | null;
  patient_city: string;
  patient_state: string;
  patient_zip_code: string;
  patient_cell_number: string;
  patient_gross_monthly_household_income: number;
  patient_number_of_people_in_household: number;
  patient_current_diagnosis: string;
  patient_current_product_used: string;
  patient_new_request_renewal: string;
  patient_email: string;
  patient_language_preference: string | null;
  prescriber_first_name: string | null;
  prescriber_last_name: string | null;
  prescriber_specialty: string | null;
  prescriber_npi: string | null;
  prescriber_address_line1: string | null;
  prescriber_address_line2: string | null;
  prescriber_city: string | null;
  prescriber_state: string | null;
  prescriber_zip_code: string | null;
  prescriber_phone_number: string | null;
  prescription_strength: string | null;
  prescription_dosage: string | null;
  prescription_is_used: string | null;
  prescription_specialty_pharmacy_name: string | null;
  licensed_prescriber_signature: string | null;
  licensed_prescriber_signature_date: string | null;
  patient_e_signature: string | null;
  patient_signature_date: string | null;
  created_at: string;
  updated_at: string;
  patient_id: number;
  prescription_document: {
    url: string | null;
  };
  prescriber_state_license_number: string | null;
  prescriber_professional_designation: string | null;
  prescriber_email: string;
  prescriber_facility_name: string | null;
  provider_user_id: number;
  uuid: string;
  reason_for_cancellation: string | null;
  reason_for_request: string;
  shipment_date: string | null;
  reason_for_manufacturer_denied: string | null;
  reason_for_manufacturer_approved: string | null;
  prescription_additional_prescriber_instructions: string | null;
  program_name: string;
  prescription_document_url: string | null;
};

export const useQueryCompassionateRequests = (status: string) => {
  return useQuery({
    queryKey: ['compassionate-requests', status],
    queryFn: async () => {
      const { data } = await axios.get<CompassionateRequest[]>(
        `compassionate_access_requests?status=${status}`
      );
      return data;
    },
    retry: 0,
    enabled: !!localStorage.getItem('Authorization'),
  });
};
